export const faqData = [{
    question: "Does this app store my uploaded files?",
    answer: "No, files are not stored. They are removed on page reload or navigation."
}, {
    question: "Can I request content removal?",
    answer: "No need, files are automatically removed upon page reload or navigation."
}, {
    question: "Does this tool support handwritten text?",
    answer: "Yes, but accuracy depends on handwriting clarity."
}, {
    question: "What image formats are supported?",
    answer: "All image formats (JPG, PNG, BMP, GIF, WEBP, etc.)."
}, {
    question: "How do you convert a pdf to text?",
    answer: "Upload your PDF file to our tool and click 'Extract Text' to let the AI process it, and after the extraction completes click 'Copy Text' to copy the extracted text to clipboard, and use it wherever you need."
}, {
    question: "How to copy text from pdf?",
    answer: "Upload your PDF file, click 'Extract Text' and wait a few seconds for extraction to complete, and then click the 'Copy to Clipboard' button."
}, {
    question: "Does this tool work on mobile devices?",
    answer: "Yes, it works on mobile. Full optimization for best experience is in progress."
}, {
    question: "Is this tool free to use?",
    answer: "We have both free and premium plans. You can start free and upgrade anytime for premium features. Check out our Pricing page to compare plans and choose what suits you best."
}, {
    question: "What is your refund policy?",
    answer: "We offer a 30-day refund policy only for Yearly and Lifetime plans. If you're not satisfied with the service, you may request a full refund within 30 days of your purchase - no questions asked. To request a refund, contact us at support@easyimagetotext.com"
}, {
    question: "Where can I manage my subscription?",
    answer: "You can manage your subscription from the “Billing Details” section in your Account Information page."
}, {
    question: "What makes this app different?",
    answer: <ul>
                <li>High accuracy, AI-powered, with dual-API support</li>
                <li>Well-formatted output, ready to use instantly</li>
                <li>Snap and extract feature (camera support)</li>
                <li>100% ad-free user experience. 100% privacy (no data stored)</li>
                <li>Affordable premium plans</li>
            </ul>
}, {
    question: "How can I contact you for queries or support?",
    answer: "Reach us anytime at support@easyimagetotext.com"
}]